import React, { Component } from 'react';
import { Modal, Switch, Spin, Tooltip,Pagination,Empty,Button, Row, Col } from 'antd';
import { LeftOutlined, RightOutlined,UndoOutlined,MinusCircleOutlined, LogoutOutlined, ReloadOutlined} from '@ant-design/icons';
import formDataSchema from '../../../../schema/user-list';
import doctorlist from '../../../../schema/doctor_list';
import Select2 from '../../../../components/FormComponent/select2';
import Select2multiple from '../../../../components/FormComponent/select2/multiple';
import { formData } from '../../../../schema/apppointment';
import networkList from '../../../../constants/networkList';
import postService from '../../../../services/httpService';
import { CSVLink } from "react-csv";
import moment from 'moment';
const { confirm } = Modal;
const $ = require('jquery');
const {homepage} = networkList;
var url = window.location.href
var arr = url.split("/");
var hostname = arr[0] + "//" + arr[2]
class User_List extends Component {
    csvLink = React.createRef()
    constructor(props) {
        super(props);
        this.state = {
            'loadding': false,
            'thead': [],
            'showFilter': true,
            'tbody': [],
            "showAdd": true,
            "showEdit": false,
            'tableTitle': '',
            'addText': '',
            'formData': [],
            activePage: 1,
            perPage: 20,
            totalItemsCount: 0,
            showPagination: false,
            'search_key': '',
            'role_id': '',
            'payer_type':'',
            'unit': '',
            'department_id':'',
            req_from_paginate: false,
            downloadStatus:0,
            downloadtbody: [],
            'theadDownload':[]
        }
    }

    componentDidMount() {
        let { id, slug } = this.props.match.params
        let { menuList } = this.props;
        menuList.map((menu) => {
            if (slug !== undefined && slug !== null && slug !== '') {
                if (menu['route'] === id) {
                    menu['submenu'].map((smenu) => {
                        if (smenu['route'] === slug) {
                            this.setState((state) => ({
                                "showAdd": JSON.parse(smenu['permissions']['add']),
                                "showEdit": JSON.parse(smenu['permissions']['edit'])
                            }));
                        }
                    })
                }
            }
        })

        this.setState((state) => ({ 'loadding': true }), () => {
            this.loadPage();
        })
        
    }


    componentDidUpdate(prevProps, prevState) {
        try {
            let { id, slug } = this.props.match.params;
            let { menuList } = this.props;
            let prevSlug = prevProps.match.params.slug;
            if (slug !== prevSlug) {
                menuList.map((menu) => {
                    if (slug !== undefined && slug !== null && slug !== '') {
                        if (menu['route'] === id) {
                            menu['submenu'].map((smenu) => {
                                if (smenu['route'] === slug) {
                                    this.setState((state) => ({
                                        "showAdd": JSON.parse(smenu['permissions']['add']),
                                        "showEdit": JSON.parse(smenu['permissions']['edit'])
                                    }));
                                }
                            })
                        }
                    }
                })

                this.setState((state) => ({ 'loadding': true }), () => {
                    this.loadPage();
                })
            }
        } catch (error) {
            console.log(error);
        }
    }

    componentWillUnmount() {
        $('footer').css({ 'position': 'relative', top: 'unset' });
        this.setState({ formData: [],activePage:1 });
    }

    loadPage = (page) => {
        try {
            let { slug } = this.props.match.params;
            const { getRolesList, getUsersListFull, getDoctorsList, getCounsellingStations } = networkList;
            let { activePage, req_from_paginate } = this.state;
            this.setState((state) => ({ showPagination: true }));
            let tableHead = [];
            const params = new URLSearchParams(this.props.location.search);
                let parmas_activePage = Number(params.get('page_no'));
                let This=this
            switch (slug) {
                case 'users':
                    
                    // if( parmas_activePage !== NaN && parmas_activePage !== null && parmas_activePage !== 'null' && parmas_activePage !== undefined && parmas_activePage !== '' && parmas_activePage !== 0 ){
                    //     if( parmas_activePage !== activePage ){
                    //         if( req_from_paginate === false ){
                    //             activePage = parmas_activePage
                    //         }
                    //     }
                    // }
                    let search_key = params.get('search_key');
                    if( search_key === null || search_key === 'null' || search_key === undefined || search_key === '' ){
                        search_key = '';
                    }
                    
                    let unit = params.get('unit');
                    if( unit === null || unit === 'null' || unit === undefined || unit === '' ){
                        unit = '';
                    }

                    let role_id = params.get('role_id');
                    if( role_id === null || role_id === 'null' || role_id === undefined || role_id === '' ){
                        role_id = '';
                    }
                    let payer_type = params.get('payer_type');
                    if( payer_type === null || payer_type === 'null' || payer_type === undefined || payer_type === '' ){
                        payer_type = '';
                    }
                    tableHead = [
                        {
                            "key": 's_no',
                            'text': 's.no'
                        }, {
                            "key": 'username',
                            'text': 'user Name'
                        }, {
                            "key": 'userid',
                            'text': 'user ID'
                        }, {
                            "key": 'phone_number',
                            'text': 'Phone Number'
                        }, {
                            "key": 'unitname',
                            'text': 'Unit'
                        }, {
                            "key": 'rolename',
                            'text': 'Role',
                        }, {
                            "key": 'counselling_station_name',
                            'text': 'Default Station Name'  
                        },
                        {
                            "key": 'user_payer_type',
                            'text': 'User Payer Type'  
                        },
                        {
                            "key": 'latest_login_time',
                            'text': 'Latest Login Time'  
                        },
                        {
                            "key": 'cabin_name',
                            'text': 'Cabin Name'  
                        },
                        {
                            "key": 'release_cabin',
                            'text': 'Release Cabin'  
                        },
                        {
                            "key": 'log_out',
                            'text': 'Log Out'  
                        },
                        {
                            "key": 'rest_password',
                            'text': 'Rest Password'  
                        },
                         {
                            "key": 'status',
                            'text': 'Status'
                        },
                        {
                            "key": 'tvdisplay_status',
                            'text': 'TV Display'
                        },
                        {
                            "key": 'action',
                            'text': 'Action'
                        }
                    ]
                    let formSchema = Object.assign({}, formDataSchema);
                    formSchema['feilds'].map((feild, key)=>{
                        if (feild['name'] === 'name') {
                            feild['text'] = null;
                            feild['value'] = null;
                        }
                        if (feild['name'] === 'unit') {
                            feild['text'] = null;
                            feild['value'] = null;
                        }
                        if (feild['name'] === 'role_id') {
                            feild['text'] = null;
                            feild['value'] = null;
                        }
                        if(feild['name'] === 'payer_type'){
                            feild['text'] = null;
                            feild['value'] = null;
                        }
                    })
                    this.setState({ 'formData': formSchema['feilds'] });

                    this.setState((state) => ({ showFilter: true, addText: 'User', tableTitle: 'User List', thead: tableHead,req_from_paginate: false  }), () => {
                        this.props.history.push('/settings/users?search_key='+search_key+'&unit='+unit+'&role_id='+role_id+'&payer_type='+payer_type+'&page_no='+activePage);
                        postService(getUsersListFull, 'POST', { 'page_no': page?activePage:1, 'search_key': search_key, 'unit': unit, 'role_id': role_id, 'payer_type': payer_type}).then(res => {
                            console.log(res);
                            if (res.status) {
                                this.setState((state) => ({ tbody: res.data, loadding: false,showView: true,totalItemsCount: res.total_items, perPage: res.perPage, activePage: page?activePage:1 }));
                            }else{
                                this.setState((state) => ({ tbody: '', loadding: false}));
                            }
                        });
                    });
                    break;
                case 'roles':
                    tableHead = [
                        {
                            "key": 's_no',
                            'text': 's.no'
                        }, {
                            "key": 'name',
                            'text': 'Role Name',
                        },
                        {
                            "key": 'action',
                            'text': 'Action'
                        }]
                    this.setState((state) => ({ showFilter: false, addText: ' Role', tableTitle: 'Roles List', thead: tableHead }), () => {
                        postService(getRolesList, 'GET', null).then(res => {
                            console.log(res);
                            if (res.status) {
                                this.setState((state) => ({ tbody: res.data, loadding: false ,totalItemsCount:res.data.length, perPage:20, activePage: activePage}));
                            }
                        });
                    });
                    break;

                case 'doctors':
                    let search = params.get('search_key');
                    if( search === null || search === 'null' || search === undefined || search === '' ){
                        search = '';
                    }
                    
                    let unitid = params.get('unit');
                    if( unitid === null || unitid === 'null' || unitid === undefined || unitid === '' ){
                        unitid = '';
                    }

                    let department_id = params.get('department_id');
                    if( department_id === null || department_id === 'null' || department_id === undefined || department_id === '' ){
                        department_id = '';
                    }
                    tableHead = [
                        {
                            "key": 's_no',
                            'text': 's.no'
                        }, {
                            "key": 'name',
                            'text': 'Doctor Name',
                        },{
                            "key": 'id',
                            'text': 'Doctor ID',
                        }, {
                            "key": 'unitname',
                            'text': 'unit',
                        }, {
                            "key": 'departmentname',
                            'text': 'Department',
                        },
                        {
                            "key": 'counsellor_name',
                            'text': 'Tagged Counsellor(s)',
                        },
                        {
                            "key": 'phone_number',
                            'text': 'Phone Number',
                        },
                        {
                            "key": 'send_whatsapp_sms',
                            'text': 'Whatsapp Sent',
                        },
                        {
                            "key": 'care_management',
                            'text': 'Care Management',
                        },
                        {
                            "key": 'action',
                            'text': 'Action'
                        }]
                        let doctorlistSchema = Object.assign({}, doctorlist);
                        doctorlistSchema['feilds'].map((feild, key)=>{
                            if (feild['name'] === 'doctorName') {
                                feild['text'] = null;
                                feild['value'] = null;
                            }
                            if (feild['name'] === 'unit') {
                                feild['text'] = 'Select  Unit';
                                feild['value'] = null;
                            }
                            if (feild['name'] === 'department') {
                                feild['text'] = 'Select Department';
                                feild['value'] = null;
                            }
                        })
                        this.setState({ 'formData': doctorlistSchema['feilds'] }); 
                        this.setState((state) => ({ showFilter: true, addText: ' Doctor', tableTitle: 'Doctors List', thead: tableHead,showPagination:true }), () => {
                        this.props.history.push('/settings/doctors?search_key='+search+'&unit='+unitid+'&department_id='+department_id+'&page_no='+activePage);
                        postService(getDoctorsList, 'POST',{ 'page_no': page?activePage:1, 'search_key': search, 'unit': unitid, 'department_id': department_id }).then(res => {
                            console.log('DOC',res);
                            if (res.status) {
                                const modifiedData = res.data.map(item => {
                                    let send_whatsapp_sms;
                                        if (item.send_whatsapp_sms === '0' || item.send_whatsapp_sms === '1') {
                                            send_whatsapp_sms = item.send_whatsapp_sms === '1' ? 'Yes' : 'No';
                                        } else {
                                            send_whatsapp_sms = '--'; // Set to 'NA' if neither '0' nor '1'
                                        }
                                        // 
                                    // Process notification_email field
                                        let care_management;
                                        if (item.care_management === '1' || item.care_management === '2') {
                                            care_management = item.care_management === '1' ? 'Medical' : 'Surgical';
                                        } else if(item.care_management === '3') {
                                            care_management = 'Medical,Surgical'; // Set to '--' if neither '0' nor '1'
                                        }else{
                                            care_management = '--';
                                        }

                                        // Return the modified item
                                        return { ...item, send_whatsapp_sms, care_management };
                                });
                                this.setState((state) => ({ tbody: modifiedData, loadding: false,totalItemsCount: res.total_items, perPage: res.perPage, activePage: page?activePage:1  }));
                                setTimeout(function () {
                                    This.setState((state) => ({ downloadStatus: 1 }))
                                    }, 2000);
                            }
                            else{
                                this.setState((state) => ({ tbody: '', loadding: false}));
                            }
                        });
                    });
                    break;
                case 'counselling-stations':
                    tableHead = [
                        {
                            "key": 's_no',
                            'text': 's.no'
                        }, {
                            "key": 'counselling_station_name',
                            'text': 'Name'
                        }, {
                            "key": 'unitname',
                            'text': 'Unit'
                        }, {
                            "key": 'cabin_count',
                            'text': 'Cabin Count'
                        } ,{
                            "key": 'tv_url',
                            'text': 'TV URL'
                        },
                        {
                            "key": 'action',
                            'text': 'Action'
                        }
                    ]
                    this.setState((state) => ({ showFilter: false, addText: 'Counselling Station', tableTitle: 'Counseliing Stations', thead: tableHead }), () => {
                        postService(getCounsellingStations, 'POST', { "page_no": page?activePage:1 }).then(res => {
                            if (res.status) {
                                this.setState((state) => ({ tbody: res.data, loadding: false,totalItemsCount: res.total_items, perPage: res.perPage, activePage: page?activePage:1  }));
                            }
                        });
                    });
                    break;
                default:
                    break;    
            }
        } catch (error) {
            console.log(error);
        }
    }

    onChange(checked, data) {
        try {
            const { changeUserStatus, changeCounsellingStationStatus } = networkList;
            let { slug } = this.props.match.params;
            let obj = {};

            switch (slug) {
                case 'users':
                    this.setState((state) => ({ 'loadding': true }), () => {
                        this.loadPage();
                    })
                    obj = { "user_id": data['id'], "status": 0 }
                    if (checked) {
                        obj['status'] = 1;
                    }
                    let This = this;
                    confirm({
                        title: "Are you sure you want to delete this user",
                        content: "",
                        onOk() {
                    postService('changeUserStatus', 'POST', { 'data': obj }).then(res => {
                        console.log(res);
                        if (res.status) {
                            
                            Modal.success({
                                title: 'Success message',
                                content: res['message'],
                                onOk: function () {
                                    This.setState((state) => ({tbody:[], 'loadding': false }), () => {
                                        This.loadPage();
                                    })
                                }
                            });
                            // this.setState((state) => ({ tbody: res.data, loadding: false }));
                        }else{
                            this.setState((state)=>({'loadding': false}))
                            Modal.error({
                                title: 'Error message',
                                content: 'Something went wrong. Please,try again later',
                                onOk: function () {
                                    window.scrollTo(0, 0);
                                }
                            });
                        }
                    });
                },
                onCancel() {
                    This.setState((state) => ({ tbody:[],'loadding': true}));
                    This.loadPage();
                },

                 
                    });
                    this.loadPage();
                    break;
                case 'counselling-stations':
                    this.setState((state) => ({ 'loadding': true }), () => {
                        this.loadPage();
                    })
                    obj = { "cs_id": data['id'], "status": 0 }
                    if (checked) {
                        obj['status'] = 1;
                    }
                    const { changeCounsellingStationStatus } = networkList;
        
        
                    postService('changeCounsellingStationStatus', 'POST', obj ).then(res => {
                        console.log(res);
                        if (res.status) {
                            let This = this;
                            Modal.success({
                                title: 'Success message',
                                content: res['message'],
                                onOk: function () {
                                    This.setState((state) => ({ 'loadding': false }), () => {
                                        This.loadPage();
                                    })
                                }
                            });
                            this.setState((state) => ({ tbody: res.data, loadding: false }));
                        }else{
                            this.setState((state)=>({'loadding': false}))
                            Modal.error({
                                title: 'Error message',
                                content: 'Something went wrong. Please,try again later',
                                onOk: function () {
                                    window.scrollTo(0, 0);
                                }
                            });
                            this.setState((state) => ({ tbody: res.data, loadding: false }));
                        }
                    });
                    break;
                default:
                    break;
            }
        } catch (error) {
            console.log(error);
            this.setState((state)=>({'loadding': false}))
            Modal.error({
                title: 'Error message',
                content: 'Something went wrong. Please,try again later',
                onOk: function () {
                    window.scrollTo(0, 0);
                }
            });
        }
    }
    ontvChange(checked, data) {
        try {
            const { changeUserTVdisplayStatus } = networkList;
            let { slug } = this.props.match.params;
            let obj = {};

            switch (slug) {
                case 'users':
                    this.setState((state) => ({ 'loadding': true }), () => {
                        this.loadPage();
                    })
                    obj = { "user_id": data['id'], "status": 0 }
                    if (checked) {
                        obj['status'] = 1;
                    }
                    postService(changeUserTVdisplayStatus, 'POST', { 'data': obj }).then(res => {
                        console.log(res);
                        if (res.status) {
                            let This = this;
                            Modal.success({
                                title: 'Success message',
                                content: res['message'],
                                onOk: function () {
                                    This.setState((state) => ({ 'loadding': false }), () => {
                                        This.loadPage();
                                    })
                                }
                            });
                            // this.setState((state) => ({ tbody: res.data, loadding: false }));
                        }else{
                            this.setState((state)=>({'loadding': false}))
                            Modal.error({
                                title: 'Error message',
                                content: 'Something went wrong. Please,try again later',
                                onOk: function () {
                                    window.scrollTo(0, 0);
                                }
                            });
                        }
                    });
                    break;
                default:
                    break;
                }
            } catch (error) {
                console.log(error);
                this.setState((state)=>({'loadding': false}))
                Modal.error({
                    title: 'Error message',
                    content: 'Something went wrong. Please,try again later',
                    onOk: function () {
                        window.scrollTo(0, 0);
                    }
                });
            }
        }
                
    addUser = () => {
        let { slug } = this.props.match.params;

        switch (slug) {
            case 'users':
                this
                    .props
                    .history
                    .push(`/settings/add-user`);
                break;
            case 'roles':
                this
                    .props
                    .history
                    .push(`/settings/add-role`);
                break;
            case 'doctors':
                this
                    .props
                    .history
                    .push(`/settings/add-doctor`);
                break;
            case 'counselling-stations':
                this
                    .props
                    .history
                    .push(`/settings/add-counselling-stations`);
                break;
            default:
                break;
        }

    }
    editUser = () => {
        this
            .props
            .history
            .push(`/settings/edituser`);
    }
    userDetails = () => {
        this
            .props
            .history
            .push(`/settings/user-details`);
    }
    viewDetails(data) {
        try {
            let { slug } = this.props.match.params;
            if (slug === 'users') {
                this
                    .props
                    .history
                    .push('/settings/view-user?rid=' + data['id']);
            }
            if (slug === 'doctors') {
             window.open(`${homepage}/settings/view-doctor?rid=${data['id']}&unid=${data['fk_unit_id']}`, '_blank', 'noopener,noreferrer');
            }
            if (slug === 'roles') {
                this
                    .props
                    .history
                    .push('/settings/view-role?rid=' + data['id']);
            }
        } catch (error) {
            console.log(error)
        }
    }
    editclick(data) {
        try {
            let { slug } = this.props.match.params;
            if (slug === 'users') {
                this
                    .props
                    .history
                    .push('/settings/edit-user?rid=' + data['id']);
            }
            if (slug === 'doctors') {
                //window.open(`${homepage}/settings/edit-doctor?rid=${data['id']}&unid=${data['fk_unit_id']}`, '_blank', 'noopener,noreferrer');
                this
                    .props
                    .history
                    .push(`/settings/edit-doctor?rid=${data['id']}&unid=${data['fk_unit_id']}`);                    
            }
            if (slug === 'roles') {
                this
                    .props
                    .history
                    .push('/settings/edit-role?rid=' + data['id']);
            }
            if (slug === 'counselling-stations') {
                this
                .props
                .history
                .push('/settings/edit-counselling-stations?rid=' + data['id']);
            }
        } catch (error) {
            console.log(error)
        }
    }
    handleChange(ele) {
        let value = ele.value;
        console.log('ELE', ele);
        if (ele.name === 'unit') {
            // console.log('ele.name', value)
            this.setState((state) => ({ 'activePage': 1, 'unit': value }), () => {
                this.renderBody();
            });
        }
        if (ele.name === 'role_id') {
            this.setState((state) => ({ 'activePage': 1, 'role_id': value }), () => {
                console.log('ROLE:::', value)
                this.renderBody();
            });
        }
        if (ele.name === 'department') {
            this.setState((state) => ({ 'activePage': 1, 'department_id': ele.text }), () => {
                this.renderBody();
            });
        }
        if (ele.name === 'payer_type') {
            this.setState((state) => ({ 'activePage': 1, 'payer_type': ele.value }), () => {
            });
        }
    }
    renderBody() {
        const { getUsersListFull,getDoctorsList } = networkList;
        let { search_key, activePage, unit, role_id ,department_id,payer_type} = this.state;
        console.log('PAY!!!', search_key, activePage, unit, role_id ,department_id,payer_type);
        this.setState((state) => ({ loadding: true }));
        let { slug } = this.props.match.params;
        let This=this
        switch (slug) {
        case 'users':
            postService(getUsersListFull, 'POST', { 'page_no': activePage, 'search_key': search_key, 'unit': unit, 'role_id': role_id, counsellerPayerType: payer_type}).then(res => {
                this.props.history.push('/settings/users?search_key='+search_key+'&unit='+unit+'&role_id='+role_id+'&page_no='+activePage);
                this.setState((state) => ({ loadding: false }));
                if (res.data && Array.isArray(res['data']) && res['data'].length !== 0) {
                    if (res.status) {
                        this.setState((state) => ({ tbody: res.data, loadding: false, totalItemsCount: res.total_items, perPage: res.perPage, showPagination: true }));
                    }
                } else {
                    this.setState((state) => ({ tbody: [], loadding: false, totalItemsCount: 0, perPage: res.perPage, showPagination: true }));
                }
            })
        break;
        case 'doctors':
            postService(getDoctorsList, 'POST', { 'page_no': activePage, 'search_key': search_key, 'unit': unit, 'department_id': department_id }).then(res => {
                this.props.history.push('/settings/doctors?search_key='+search_key+'&unit='+unit+'&department_id='+department_id+'&page_no='+activePage);
                this.setState((state) => ({ loadding: false }));
                // if (res.data && Array.isArray(res['data']) && res['data'].length !== 0) {
                //     if (res.status) {
                //         this.setState((state) => ({ tbody: res.data, loadding: false, totalItemsCount: res.total_items, perPage: res.perPage, showPagination: true }));
                //     }
                // } 
                if (res.status) {
                    const modifiedData = res.data.map(item => {
                        // let send_whatsapp_sms;
                        //     if (item.send_whatsapp_sms === '0' || item.send_whatsapp_sms === '1') {
                        //         send_whatsapp_sms = item.send_whatsapp_sms === '1' ? 'Yes' : 'No';
                        //     } else {
                        //         send_whatsapp_sms = '--'; // Set to 'NA' if neither '0' nor '1'
                        //     }
                        //     return { ...item, send_whatsapp_sms };
                            let care_management;
                            if (item.care_management === '1' || item.care_management === '2') {
                                care_management = item.care_management === '1' ? 'Medical' : 'Surgical';
                            } else if(item.care_management === '3') {
                                care_management = 'Medical,Surgical'
                            }else {
                                care_management = '--'; // Set to 'NA' if neither '0' nor '1'
                            }
                            return { ...item, care_management };
                    });
                    this.setState((state) => ({ tbody: modifiedData, loadding: false,totalItemsCount: res.total_items, perPage: res.perPage, showPagination: true  }));
                    setTimeout(function () {
                        This.setState((state) => ({ downloadStatus: 1 }))
                        }, 2000);
                }
                else {
                    this.setState((state) => ({ tbody: [], loadding: false, totalItemsCount: 0, perPage: res.perPage, showPagination: true }));
                }
            })
            break;  
        default:
            break;    
    }
        
    }

    itemRender(current, type, originalElement) {
        if (type === 'prev') {
            return <a><LeftOutlined /></a>;
        }
        if (type === 'next') {
            return <a><RightOutlined /></a>;
        }
        return originalElement;
    }

    handlePageChange(page) {
        this.setState((state) => ({
            activePage: page,
            // req_from_paginate: true,
            tbody: []
        }), () => {
            this.loadPage(page);
            // this.renderBody();
        })
    }

    searchChange(e) {
        let value = e.target.value
        this.setState((state) => ({ 'search_key': value }), () => {
        });
    }
    searchClick() {
        
        this.setState((state) => ({ 'page_data_count': 1 }), () => {
            let { search_key } = this.state;
            this.setState({ activePage: 1 })
            let { formData } = this.state;
            formData.map((feild, key) => {
                // console.log('feild', feild)
                if (feild.name === 'unit') {
                    formData[key]['value'] = null;
                    formData[key]['text'] = null;
                }
                if (feild.name === 'department_id') {
                    formData[key]['value'] = null;
                    formData[key]['text'] = null;
                }
                if (feild.name === 'role_id') {
                    formData[key]['value'] = null;
                    formData[key]['text'] = null;
                }
            })
            this.setState((state) => ({ 'unit': '', 'role_id': '','department_id':'' }), () => {
                this.renderBody();
            });
        })
       
    }
    downloadFile(){
        try {
            let { slug } = this.props.match.params;
            const { getRolesList, getUsersListFull, getDoctorsList, getCounsellingStations } = networkList;
            let { activePage, req_from_paginate } = this.state;
            this.setState((state) => ({ showPagination: true }));
           
            const params = new URLSearchParams(this.props.location.search);
                let parmas_activePage = Number(params.get('page_no'));
            let This=this
            switch (slug) {
                    
                case 'doctors':
                    let search = params.get('search_key');
                    if( search === null || search === 'null' || search === undefined || search === '' ){
                        search = '';
                    }
                    
                    let unitid = params.get('unit');
                    if( unitid === null || unitid === 'null' || unitid === undefined || unitid === '' ){
                        unitid = '';
                    }

                    let department_id = params.get('department_id');
                    if( department_id === null || department_id === 'null' || department_id === undefined || department_id === '' ){
                        department_id = '';
                    }
                    let tableHead = [];
                    tableHead = [
                        {
                            "key": 'name',
                            'label': 'Doctor Name',
                        },
                        {
                            "key": 'id',
                            'label': 'Doctor ID',
                        }, 
                        {
                            "key": 'unitname',
                            'label': 'unit',
                        }, 
                        {
                            "key": 'departmentname',
                            'label': 'Department',
                        },
                        {
                            "key": 'counsellors',
                            'label': 'Tagged Counsellor(s)',
                        },
                        {
                            "key": 'phone_number',
                            'label': 'Phone Number',
                        },
                        {
                            "key": 'send_whatsapp_sms',
                            'label': 'Whatsapp Sent',
                        },
                        {
                            "key": 'care_management',
                            'label': 'Care Management',
                        },
                        {
                            "key": 'action',
                            'text': 'Action'
                        }
                       ]
                        this.setState((state) => ({ showFilter: true, addText: ' Doctor', tableTitle: 'Doctors List', theadDownload: tableHead,showPagination:true ,downloadStatus:0}), () => {
                        this.props.history.push('/settings/doctors?search_key='+search+'&unit='+unitid+'&department_id='+department_id+'&page_no='+activePage);
                        postService(getDoctorsList, 'POST',{ 'page_no':0, 'search_key': search, 'unit': unitid, 'department_id': department_id })
                        .then(res => {
                                if (res.status) {
                                    res.data.map((data, key) => {
                                        Object.keys(data).map((dataKey) => {
                                            if (dataKey === 'counsellors') {
                                                let counsellorname=''
                                                res.data[key][dataKey].length>0&& res.data[key][dataKey].map((previlage, key) => {
                                                    if(key!==(res.data[key][dataKey].length)-1){
                                                        counsellorname+=res.data[key][dataKey].length?previlage['counsellor_name']+',':'NA';
                                                    }else{
                                                        counsellorname+=res.data[key][dataKey].length?previlage['counsellor_name']:'NA';
                                                    }
                                                    })
                                                    res.data[key][dataKey]=counsellorname?counsellorname:'NA';
                                            }else{
                                                res.data[key][dataKey] = res.data[key][dataKey] ? res.data[key][dataKey] : 'NA'

                                                if (dataKey === 'send_whatsapp_sms') {
                                                    if (res.data[key][dataKey] === '0' || res.data[key][dataKey] === '1') {
                                                        res.data[key][dataKey] = res.data[key][dataKey] === '1' ? 'Yes' : 'No';
                                                    } else {
                                                        res.data[key][dataKey] = 'NA'; // Set to 'NA' if neither 0 nor 1
                                                    }
                                                } else {
                                                    res.data[key][dataKey] = res.data[key][dataKey] ? res.data[key][dataKey] : 'NA';
                                                }
                                                if(dataKey === 'care_management'){
                                                    if (res.data[key][dataKey] === '1' || res.data[key][dataKey] === '2') {
                                                        res.data[key][dataKey] = res.data[key][dataKey] === '1' ? 'Medical' : 'Surgical';
                                                    } else if(res.data[key][dataKey] === '3'){
                                                        res.data[key][dataKey] = 'Medical,Surgical';
                                                    } 
                                                    else {
                                                        res.data[key][dataKey] = 'NA'; // Set to 'NA' if neither 0 nor 1
                                                    } 
                                                }
                                                else {
                                                    res.data[key][dataKey] = res.data[key][dataKey] ? res.data[key][dataKey] : 'NA';
                                                }
                                            }
            
                                        })
                                    })
                                    This.setState((state) => ({ downloadtbody: res.data, loadding: false, downloadStatus: 1,total_items:res.total_items,filename:'doctorlist.csv',theadDownload: tableHead }));
                                    This.csvLink.current.link.click();
                                    }
                                else{
                                if (res === 401) {

                                } else {
                                    Modal.error({
                                        title: 'Failure',
                                        content: "Oops! something went wrong... Please try again.",
                                    });
                                }
                            }
                        });
                    });
                    break;
                default:
                    break;    
            }
        } catch (error) {
            console.log(error);
        }
    }
    clearFilter(){
        this.props.history.push('/settings/doctors?search_key=&unit=&department_id=&page_no=1');
        let {formData}=this.state
        const params = new URLSearchParams(this.props.location.search);
        this.setState({ search_key:'',unit:'', role_id:'' ,department_id:'' });
        let This=this
        let search = params.get('search_key');
        if( search === null || search === 'null' || search === undefined || search === '' ){
            search = '';
        }
        
        let unitid = params.get('unit');
        if( unitid === null || unitid === 'null' || unitid === undefined || unitid === '' ){
            unitid = '';
        }

        let department_id = params.get('department_id');
        if( department_id === null || department_id === 'null' || department_id === undefined || department_id === '' ){
            department_id = '';
        }
        formData.map((feild, key)=>{
            if (feild['name'] === 'doctorName') {
                feild['text'] = null;
                feild['value'] = null;
                feild['visible']=false;
            }
            if (feild['name'] === 'unit') {
                feild['text'] = 'Select  Unit';
                feild['value'] = null;
            }
            if (feild['name'] === 'department') {
                feild['text'] = 'Select Department';
                feild['value'] = null;
            }
        })
       
        this.setState((state)=>({ 'formData': formData,search_key:'',unit:'', role_id:'' ,department_id:'' }),() => {
                formData.map((feild, key)=>{
                    if (feild['name'] === 'doctorName') {
                        feild['visible']=true;
                        feild['text'] = null;
                    feild['value'] = null;
                    }
                })
                This.setState({'formData': formData});
                This.renderBody();
                  
        });
    }
    releaseUserCabin(data){
        let This=this;
        let payload={
             "user_id": data['id']
        }
        try {
            confirm({
                title: "Are you sure you want to Release User Cabin",
                content: "",
                onOk() {
        postService('ReleaseUserCabin', 'POST', { 'data': payload }).then(res => {
            console.log(res);
            if (res.status) {
                        This.setState((state) => ({tbody:[], 'loadding': false }), () => {
                            This.loadPage();
                        })
                  
                // this.setState((state) => ({ tbody: res.data, loadding: false }));
            }else{
                this.setState((state)=>({'loadding': false}))
                Modal.error({
                    title: 'Error message',
                    content: 'Something went wrong. Please,try again later',
                    // onOk: function () {
                    //     window.scrollTo(0, 0);
                    // }
                });
            }
        })
    },
    onCancel() {
        This.setState((state) => ({ tbody:[],'loadding': true}));
        This.loadPage();
    },})
    } catch (error) {
        console.log(error);
    }
    }


    resetPasswordByAdmin(data) {
        let This = this;
        let payload = {
          "user_id": data['id']
        };
      
        try {
          confirm({
            title: "Are you sure you want to reset the user's password?",
            content: "",
            onOk() {
              postService('resetPassword', 'POST', { 'data': payload }).then(res => {
                console.log(res);
                if (res.status) {
                  This.setState((state) => ({ tbody: [], 'loadding': false }), () => {
                    This.loadPage();
                    Modal.success({
                      title: 'Success',
                      content: `User's password has been reset successfully. ${res.message}`,
                    });
                  });
                } else {
                  This.setState((state) => ({ 'loadding': false }));
                  Modal.error({
                    title: 'Error message',
                    content: 'Something went wrong. Please try again later.',
                  });
                }
              });
            },
            onCancel() {
              // Handle cancel action if needed
            },
          });
        } catch (error) {
          console.log(error);
        }
      }
      

    userLogoutByManager(data) {
        let This = this;
        let payload = {
          "user_id": data['id']
        };
      
        try {
          confirm({
            title: "Are you sure you want to logout the user?",
            content: "",
            onOk() {
              postService('userLogoutByManager', 'POST', { 'data': payload }).then(res => {
                console.log(res);
                if (res.status) {
                  This.setState((state) => ({ tbody: [], 'loadding': false }), () => {
                    This.loadPage();
                    Modal.success({
                      title: 'Success',
                      content: 'User logged out successfully.',
                    });
                  });
                } else {
                  This.setState((state) => ({ 'loadding': false }));
                  Modal.error({
                    title: 'Error message',
                    content: 'Something went wrong. Please try again later.',
                  });
                }
              });
            },
            onCancel() {
              // Handle cancel action if needed
            },
          });
        } catch (error) {
          console.log(error);
        }
      }
      
           
    render() {
        let { slug } = this.props.match.params;
        let { tableTitle, thead, tbody, addText, showFilter, showAdd, showEdit, formData,showPagination,totalItemsCount,perPage,downloadStatus,downloadtbody,filename,theadDownload } = this.state;
        let { stationTvDisplay } = networkList;
        let userData = localStorage.getItem('user_data');
        if (userData !== undefined && userData !== null && userData !== '') {
            userData = JSON.parse(userData);
        }
        return (
            <React.Fragment>
                <div className="row mb-2 mr-5 ml-5">
                {slug==='doctors'&& (<div className="col-12 pr-0">
                {
                  (downloadStatus && tbody!=''
                            ?
                            <div className="float-right mb-2 download sticky-top d-flex flex-row-reverse">
                                <button className="btn btn-success text-capitalize" onClick={() => { this.downloadFile() }}><img src={homepage+"/assets/images/icons/download1.png"} alt="" className="pr-2" /> <span> Download Doctor</span></button>
                                <CSVLink data={downloadtbody} headers={theadDownload} filename={filename} className="hidden" ref={this.csvLink} />
                                <button className="btn btn-light text-capitalize mr-3 ml-3" onClick={() => { this.clearFilter() }}><UndoOutlined className="align-middle pr-2" /><span> Clear</span></button>
                                {/* {(showAdd) &&
                            <button className="btn btn-success text-capitalize float-right" disabled onClick={this.addUser}>add2 {addText}</button>
                        } */}
                                {/* <button className="btn btn-success text-capitalize mr-3" onClick={() => { this.submit()}}><span>Submit</span></button> */}
                            </div>
                            :
                            <div className="float-right mb-2 download sticky-top d-flex flex-row-reverse">
                                <Button className="btn btn-success-disabled text-capitalize" disabled><img src={homepage+"/assets/images/icons/download1.png"} alt="" className="pr-2" /><span> Download Doctor</span></Button>
                                <button className="btn btn-light text-capitalize mr-3 ml-3" onClick={() => { this.clearFilter() }}><UndoOutlined type="reload" className="align-middle pr-2" /><span> Clear</span></button>
                                {/* {(showAdd) &&
                            <button className="btn btn-success text-capitalize float-right" disabled onClick={this.addUser}>add1 {addText}</button>
                        } */}
                                {/* <Button className="btn btn-success text-capitalize mr-3" onClick={() => { this.submit()}}><span>Submit</span></Button> */}
                            </div>
                  )
                    }
                    </div>)}
                    {slug!=='doctors'&&(<div className="col-12 pr-0">
                        {(showAdd) &&
                            <button className="btn btn-success text-capitalize float-right" onClick={this.addUser}>add {addText}</button>
                        }
                    </div>)}
                </div>
                <Spin spinning={this.state.loadding}>
                    <div className="card ml-5 mr-5 mb-5 card-table">
                        <div className="card-header bg8">
                            {tableTitle === 'User List' ?
                            <div className="clearfix" style={{marginTop:'10px'}} >
                            <div className="float-left pt-1">
                                {tableTitle}
                            </div>
                            {(showFilter) &&
                                <div className="col-10 float-right">
                                    {(formData !== undefined) && <React.Fragment>
                                        <Row gutter={16}>
                                            {formData.map((feild, key) => {
                                                if (feild.element === 'input' && feild.visible) {
                                                    return (
                                                        <Col span={6} key={key}>
                                                            <div className="input-group" style={{marginLeft:'-20px'}}>
                                                                <input 
                                                                    type="text" 
                                                                    id="myInput" 
                                                                    className="form-control form-control-sm" 
                                                                    placeholder={feild.name === 'name' ? "User Name or User ID" : feild.name === 'doctorName' ? 'Doctor name' : ''} 
                                                                    onBlur={this.searchChange.bind(this)} 
                                                                />
                                                                <div className="input-group-append">
                                                                    <button 
                                                                        className="btn btn-primary btn-sm" 
                                                                        type="button" 
                                                                        onClick={this.searchClick.bind(this)}
                                                                    >
                                                                        <img src={homepage + "/assets/images/icons/search.png"} alt="search" />
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </Col>
                                                    );
                                                }
                                                if (feild.element === 'select2') {
                                                    return (
                                                        <>
                                                        <p style={{marginTop: '5px'}}>{feild.text2}</p>
                                                        {console.log('FEILD:::', feild.placeholder)}
                                                        <Col span={4} key={key}>
                                                            <Select2 
                                                                selectdata={feild} 
                                                                changedObj={this.state.changedObj} 
                                                                {...this.props} 
                                                                {...this.state} 
                                                                Queuedata={this.state.formData} 
                                                                onselectChanges={this.handleChange.bind(this)} 
                                                                // placeholder={feild.placeholder || 'Select'}
                                                            />
                                                            {feild.errors.map((error, eKey) => (
                                                                <small key={eKey} className="form-text text-danger">{error.message}</small>
                                                            ))}
                                                        </Col>
                                                        </>
                                                    );
                                                }
                                                // if (feild.element === 'select2multiple') {
                                                //     return (
                                                //         <>
                                                //         <p style={{marginTop: '5px'}}>{feild.text2}</p>
                                                //         {console.log('FEILD:::', feild.placeholder)}
                                                //         <Col span={4} key={key}>
                                                //                 <Select2multiple
                                                //                     Queuedata={formData}
                                                //                     selectdata={feild}
                                                //                     {...this.props}
                                                //                     {...this.state}
                                                //                     onselectChanges={this
                                                //                         .handleChange
                                                //                         .bind(this, feild)}
                                                //                 />
                                                //                  {feild
                                                //                     .errors
                                                //                     .map((error, eKey) => {
                                                //                         return (
                                                //                             <small key={eKey} className="form-text text-danger">{error.message}</small>
                                                //                         );
                                                //                     })}
                                                //             </Col>
                                                //             </>
                                                //     )
                                                // }
                                                if (feild.element === 'select2multiple') {
                                                    return (
                                                        <>
                                                            {/* <p style={{ marginTop: '5px' }}>{feild.text2}</p>
                                                            {console.log('FEILD:::', feild.placeholder)} */}
                                                            <Col span={6} key={key} style={{marginRight: '20px'}}>
                                                                <div style={{ display: 'flex', alignItems: 'center', gap: '1px'}}>
                                                                    <Select2multiple
                                                                        Queuedata={formData}
                                                                        selectdata={feild}
                                                                        {...this.props}
                                                                        {...this.state}
                                                                        onselectChanges={this.handleChange.bind(this, feild)}
                                                                    />
                                                                   
                                                                    <button
                                                                        className="btn btn-primary btn-sm"
                                                                        type="button"
                                                                        onClick={this.renderBody.bind(this, feild)}
                                                                        style={{backgroundColor: '#067fb8'}}
                                                                    >
                                                                        <img src={homepage + "/assets/images/icons/search.png"} alt="search" />
                                                                    </button>
                                                                </div>
                                                                {feild.errors.map((error, eKey) => (
                                                                    <small key={eKey} className="form-text text-danger">{error.message}</small>
                                                                ))}
                                                            </Col>
                                                        </>
                                                    );
                                                }
                                            })}
                                        </Row>
                                    </React.Fragment>}
                                </div>
                            }
                        </div>
                             :
                             <div className="clearfix">
                             <div className="float-left pt-1">
                                 {tableTitle}
                             </div>
                             {(showFilter) &&
                                 <div className="col-10 float-right">
                                     {(formData !== undefined) && <React.Fragment>
                                         <div className='row'>
                                             {formData
                                                 .map((feild, key) => {
                                                     if (feild.element === 'input' &&feild.visible) {
                                                         return (
                                                             <div class="input-group col-4">
                                                                 <input type="text" id="myInput" class="form-control form-control-sm" aria-label="Text input with dropdown button" placeholder={feild.name==='name'?"User Name or User ID":feild.name==='doctorName' && 'Doctor name'}  onBlur={this.searchChange.bind(this)} />
                                                                 <div class="input-group-append">
                                                                     <button class="btn btn-primary btn-sm" type="button" onClick={this.searchClick.bind(this)}><img src={homepage+"/assets/images/icons/search.png"}></img></button>
                                                                 </div>
                                                             </div>
                                                         )
                                                     }
                                                     if (feild.element === 'select2') {
                                                         if(feild.name==='department'){
                                                             return (
                                                                 <div className='col-4'>
                                                                             <Select2 selectdata={feild} changedObj={this.state.changedObj} {...this.props} {...this.state} Queuedata={this.state.formData} onselectChanges={this.handleChange.bind(this)} />
                                                                             {feild.errors.map((error, eKey) => {
                                                                                 return (
                                                                                     <small key={eKey} className="form-text text-danger">{error.message}</small>
                                                                                 );
                                                                             })}
                                                                         </div>
                                                             )
                                                         }
                                                         else{
                                                         return (
                                                             <div class="col-4">
                                                                 <div className='row'>
                                                                     <React.Fragment key={key}>
                                                                         <div className={`${feild.className ? feild.className : 'col '} ${feild.name}`}
                                                                             key={key} >
                                                                             <p className="data-label text-white w-75 mb-1 pt-1 text-right pr-2">{feild.text2}</p>
                                                                         </div>
                                                                         <div className='col-6'>
                                                                             <Select2 selectdata={feild} changedObj={this.state.changedObj} {...this.props} {...this.state} Queuedata={this.state.formData} onselectChanges={this.handleChange.bind(this)} />
                                                                             {feild.errors.map((error, eKey) => {
                                                                                 return (
                                                                                     <small key={eKey} className="form-text text-danger">{error.message}</small>
                                                                                 );
                                                                             })}
                                                                         </div>
                                                                     </React.Fragment>
                                                                 </div>
                                                             </div>
                                                         )
                                                      }
                                                     }
                                                     
                                                    
                                                 })}
                                     
                                         </div>
                                     </React.Fragment>}
                                 </div>}
                         </div>
                            }
                        </div>
                        <div className="financial-table table-responsive">
                            <table className="table table-hover table-bordered mb-0">
                                <thead>
                                    <tr>
                                        {thead.map((head, key) => {
                                            return (<td className="text-capitalize" key={key}>{head['text']}</td>)
                                        })}
                                    </tr>
                                </thead>
                                <tbody>
                                    {tbody&& tbody.map((body, key) => {
                                        return (<tr key={key}>

                                            {thead.map((head, Hkey) => {
                                                if (head['key'] === 's_no') {
                                                    return (<td>{key + 1 + (this.state.activePage > 1 ? perPage * (this.state.activePage > 2 ? (this.state.activePage - 1) : 1) : 0)}</td>)
                                                }

                                                if (head['key'] === 'tv_url') {
                                                    return (<td>{(body[head['key']] !== null) ? `${hostname + homepage + '/' + stationTvDisplay}` + body[head['key']] : '--'}</td>)
                                                }

                                                if (head['key'] === 'action') {
                                                    return (
                                                      <td key={Hkey}>
                                                        {(showEdit) && <img src={homepage+"/assets/images/icons/edit.png"} alt="edit" title="edit" className="mr-2" onClick={() => this.editclick(body)} />}
                                                        <img src={homepage+"/assets/images/icons/view.png"} alt="view" title="view" onClick={() => this.viewDetails(body)} />
                                                        {/* {(showEdit) && <ReloadOutlined title="reset password" className="mr-2" style={{color: '#008000', fontSize: '18px'}} onClick={() => this.resetPasswordByAdmin(body)}/>}
                                                        {(showEdit)&& (body.login_status === "1") && <LogoutOutlined title="logout" className="mr-2" style={{color: '#ff0000', fontSize: '17px'}} onClick={() => this.userLogoutByManager(body)}/>} */}
                                                      </td>
                                                    );
                                                  }

                                                if (head['key'] === 'status') {
                                                    return (<React.Fragment>
                                                        {(showEdit) &&
                                                            <React.Fragment>
                                                                {(body.status !== undefined && body.status !== null && (body.status === 1 ||  body.status === "1")) &&
                                                                    <td><Switch defaultChecked onChange={(status) => this.onChange(status, body)} /></td>
                                                                }
                                                                {(body.status !== undefined && body.status === null ||  (body.status === 0 ||  body.status === "0")) &&
                                                                    <td><Switch onChange={(status) => this.onChange(status, body)} /></td>
                                                                } </React.Fragment>}
                                                        {(!showEdit) && <td>{(body.status && body.status !== null) ? (body.status === '1') ? 'Active' : 'In Active' : '--'}</td>}
                                                    </React.Fragment>)
                                                }
                                                if (head['key'] === 'tvdisplay_status') {
                                                    return (<React.Fragment>
                                                        {/* { body.roleid === 'RL_HjPW' ? */}
                                                            <React.Fragment> 
                                                                {(showEdit) &&
                                                                <React.Fragment>
                                                                    {(body.enable_tv_display !== undefined && body.enable_tv_display !== null && (body.enable_tv_display === 1 ||  body.enable_tv_display === "1")) &&
                                                                        <td><Switch defaultChecked onChange={(enable_tv_display) => this.ontvChange(enable_tv_display, body)} /></td>
                                                                    }
                                                                    {(body.enable_tv_display !== undefined && body.enable_tv_display === null ||  (body.enable_tv_display === 0 ||  body.enable_tv_display === "0")) &&
                                                                        <td><Switch onChange={(enable_tv_display) => this.ontvChange(enable_tv_display, body)} /></td>
                                                                    } </React.Fragment>}
                                                                    {(!showEdit) && <td>{(body.enable_tv_display && body.enable_tv_display !== null) ? (body.enable_tv_display === 1) ? 'Active' : 'In Active' : '--'}</td>}                                                       
                                                            </React.Fragment> 
                                                         {/* : <td><Switch disabled /></td>} */}
                                                    </React.Fragment>)
                                                }
                                                if (head['key'] === 'counsellor_name') {
                                                    return (
                                                            <td className="text-capitalize">                                                      
                                                                {(body['counsellors']&&body['counsellors'].length>0) ?
                                                                    <React.Fragment>
                                                                            {(body['counsellors']).map((previlage, key) => {
                                                                                return (<div  key={key}><p>{previlage['counsellor_name']}</p></div>)
                                                                                })
                                                                            }
                                                                    </React.Fragment>
                                                                : '--'}
                                                                
                                                            </td>)
                                                }
                                                if (head['key'] === 'latest_login_time') {
                                                    return (<td>{body['latest_login_time'] ? moment(body['latest_login_time']).format('DD-MM-YYYY HH:mm A') : 'NA'}</td>)
                                                }
                                                if (head['key'] === 'release_cabin') {
                                                    return (<td className='text-center'>{body['cabin_name']?<Tooltip title="Release User Cabin"><MinusCircleOutlined  className='circlefontsize' onClick={this.releaseUserCabin.bind(this, body)}/></Tooltip>:'--'}</td>)
                                                }
                                                if (head['key'] === 'log_out') {
                                                    return (<td className='text-center'>{(showEdit || userData['roleid']=='RL_tSU5')&& (body.login_status === "1") && <LogoutOutlined title="logout" className="mr-2" style={{color: '#ff0000', fontSize: '23px'}} onClick={() => this.userLogoutByManager(body)}/>}
                                                    </td>)
                                                }
                                                if (head['key'] === 'rest_password') {
                                                    return (<td className='text-center'>{(showEdit ||  userData['roleid']=='RL_tSU5') && <ReloadOutlined title="reset password" className="mr-2" style={{color: '#008000', fontSize: '23px'}} onClick={() => this.resetPasswordByAdmin(body)}/>}</td>)
                                                }
                                                return (
                                                    <td className="text-capitalize">{(body[head['key']] !== null) ? body[head['key']] : '--'}</td>
                                                )

                                            })
                                            }

                                        </tr>)
                                    })}
                                
                                {(tbody && tbody.length === 0) && <React.Fragment>
                                    <tr>
                                       <td colSpan={thead.length+1} className="text-center">
                                          <img src={homepage+"/assets/images/icons/no-data.svg"} alt="" />
                                          <p className="no-data mb-0">No Data</p>
                                       </td>
                                      </tr> 
                                                    </React.Fragment>}  
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="row justify-content-center align-item-center mx-0">
                        <div className="col pagenation-col mb-3">
                            {(showPagination) && <Pagination current={this.state.activePage} total={totalItemsCount} itemRender={this.itemRender.bind(this)} pageSize={perPage} showSizeChanger={false} onChange={this.handlePageChange.bind(this)} />}
                        </div>
                    </div>
                </Spin>
            </React.Fragment>
        )
    }
}

export default User_List;